import React from 'react';
import { HStack, Link, Box } from '@chakra-ui/react';
import { FaFacebook, FaYoutube, FaLinkedin, FaInstagram } from 'react-icons/fa';

const SocialMediaLinks = () => {
  const socialLinks = [
    {
      name: 'Facebook',
      icon: FaFacebook,
      url: 'https://www.facebook.com/storkplus', // You can update this link
      color: '#1877F2'
    },
    {
      name: 'YouTube',
      icon: FaYoutube,
      url: 'https://www.youtube.com/@StorkpLus', // You can update this link
      color: '#FF0000'
    },
    {
      name: 'LinkedIn',
      icon: FaLinkedin,
      url: 'https://www.linkedin.com/company/storkplus', // You can update this link
      color: '#0A66C2'
    },
    {
      name: 'Instagram',
      icon: FaInstagram,
      url: 'https://www.instagram.com/storkplusmarketplace', // You can update this link
      color: '#E4405F'
    }
  ];

  return (
    <Box textAlign="center" mt={6}>
      <HStack spacing={4} justify="center">
        {socialLinks.map((social) => (
          <Link
            key={social.name}
            href={social.url}
            isExternal
            _hover={{
              transform: 'scale(1.1)',
              transition: 'transform 0.2s ease'
            }}
          >
            <Box
              as={social.icon}
              fontSize="24px"
              color={social.color}
              transition="all 0.2s ease"
              _hover={{
                filter: 'brightness(1.2)'
              }}
            />
          </Link>
        ))}
      </HStack>
    </Box>
  );
};

export default SocialMediaLinks;